import { defaultCalculationRule } from '../../../model';

export const initialValues = {
    calculationRules: defaultCalculationRule,
    commission: {
        value: '',
    },
};
